import { showAlert } from '../../../redux/slices/appSlice';
import { useAppDispatch } from '../../../hooks/reduxHooks';
import { useGetEnabledDocsQuery } from '../../../services/documentsApi';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useUpload from './useUpload';

function useCargaDocumentos() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [data, setData] = useState<any>(null);
    const [errors, setErrors] = useState<any>(null);
    const { ...uploadProps } = useUpload();

    const {
        data: enabledDocs,
        isLoading: loadingEnabledDocs,
        isFetching: fetchingEnabledDocs
    } = useGetEnabledDocsQuery(undefined, {
        refetchOnMountOrArgChange: false
    });

    const handleChange = (e: any) => {
        const { name, value, type } = e?.target;

        const deleteAction = () => {
            let auxData = { ...data };
            delete auxData?.[name];
            setData(auxData);
        };

        if (!value) {
            deleteAction();
        } else {
            if (type && type === 'file') {
                const fileTypes = data?.tipoDocumento?.tiposArchivo?.map((item: any) => item?.tipo);
                if (!fileTypes.includes(value?.type)) {
                    deleteAction();
                    return setErrors('Extensión de archivo no admitido');
                }
                if (errors) setErrors(null);
            }
            if (name === 'tipoDocumento') {
                setData({
                    [name]: value
                });
                if (errors) setErrors(null);
            } else {
                setData({
                    ...data,
                    [name]: value
                });
            }
        }
    };

    const inputTypeDocOptions = useMemo(() => {
        return enabledDocs
            ?.filter((i: any) => i.cargar)
            ?.map((item: any) => {
                let auxObject = {
                    ...item,
                    id: item.tipoDocumento.id,
                    descripcion: item.tipoDocumento.descripcion,
                    tiposArchivo: item.tipoDocumento.tiposArchivo,
                    nombre: item.tipoDocumento.nombre
                };
                delete auxObject['tipoDocumento'];
                return auxObject;
            });
    }, [enabledDocs]);

    const handleCancelUpload = () => {
        dispatch(
            showAlert({
                title: '¿Desea cancelar la carga de documentos?',
                cancelText: 'Volver',
                confirmText: 'Sí, cancelar',
                confirmAction: () => navigate('/app/consula-documentos')
            })
        );
    };

    return {
        errors,
        data,
        inputTypeDocOptions,
        loadingEnabledDocs,
        fetchingEnabledDocs,
        handleChange,
        handleCancelUpload,
        ...uploadProps
    };
}

export default useCargaDocumentos;
